import { render } from "./scnd.vue?vue&type=template&id=fb3dc66c"
import script from "./scnd.vue?vue&type=script&lang=js"
export * from "./scnd.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/scada/components/scnd.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "fb3dc66c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('fb3dc66c', __exports__)) {
    console.log('reload')
    api.reload('fb3dc66c', __exports__)
  }
  
  module.hot.accept("./scnd.vue?vue&type=template&id=fb3dc66c", () => {
    console.log('re-render')
    api.rerender('fb3dc66c', render)
  })

}


export default __exports__